import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'distance'
})
export class DistancePipe extends DecimalPipe implements PipeTransform {
  private KILOMETER = 'km';
  private METER = 'm';
  private defaultDigitsInfo = '1.0-2';
  private locale = 'es';

  transform(meters, digitsInfo?) {
    const sanitizedDigitsInfo = digitsInfo ?? this.defaultDigitsInfo;
    const sanitizedMeters = +meters;
    return this._transform(sanitizedMeters, sanitizedDigitsInfo);
  }

  private _transform(meters: number, digitsInfo: string) {
    const { value, units } = this.calculateUnitsAndValue(meters);
    const transformedValue = super.transform(
      value,
      digitsInfo,
      this.locale
    );

    return transformedValue + ' ' + units as any;
  }

  private calculateUnitsAndValue(meters) {
    let value;
    let units;
    if (DistancePipe.areTooManyDistance(meters)) {
      value = DistancePipe.mToKm(meters);
      units = this.KILOMETER;
    } else {
      value = meters;
      units = this.METER;
    }

    return { value, units };
  }

  static mToKm(meters: number) {
    return meters / 1000;
  }

  static areTooManyDistance(meters: number) {
    return meters >= 1000;
  }
}
